import { BUILD_STAMP } from '../build-stamp';

/**
 * Kennung des ausgelieferten Standes - zum Nachsehen, ob der eigene Deploy
 * tatsaechlich draussen ist.
 *
 * **Bevorzugt die Commit-Kennung.** Ein Inhaltshash ist zwar eindeutig, aber
 * er sagt nichts darueber, WANN und WAS - man kann ihn keinem Stand zuordnen,
 * ohne nachzuschlagen. Die Commit-Kennung laesst sich direkt in der Historie
 * wiederfinden, und genau darum geht es, wenn etwas schiefgeht.
 *
 * Sie kommt aus `build-stamp.ts`, das `scripts/stamp-build.js` als
 * `postinstall` in der CI schreibt - aus `CI_COMMIT_SHORT_SHA`. Damit bleibt
 * die `.gitlab-ci.yml` unangetastet, die laut ihrem eigenen Kommentar in jeder
 * App identisch ist.
 *
 * **Rueckfall auf den Bundle-Hash.** Lokal und bei jedem Build ausserhalb der
 * CI bleibt der Stempel leer. Dann steht die Kennung ohnehin schon im
 * Dateinamen des Haupt-Bundles (`main.8d6ef975ac021de0.js`), seit die Bundles
 * gehasht werden.
 *
 * **Nach aussen heisst es immer "Build".** Ob dahinter eine Commit-Kennung
 * oder ein Bundle-Hash steht, ist eine Frage der Umgebung und geht den Leser
 * nichts an - er soll zwei Staende unterscheiden koennen, mehr nicht. Datum
 * und Uhrzeit stehen bewusst nicht dabei: die Zuordnung leistet die Historie,
 * und im Profil waeren sie nur Ballast.
 */
export interface BuildInfo {
  /** Commit-Kennung, ersatzweise der Inhaltshash des Haupt-Bundles. */
  build: string;
}

export function getBuildInfo(): BuildInfo {
  return { build: BUILD_STAMP.commit || leseBundleHash() };
}

function leseBundleHash(): string {
  try {
    const skripte = Array.from(document.querySelectorAll<HTMLScriptElement>('script[src]'));
    for (const skript of skripte) {
      // main.<hash>.js - der Dateiname des eigenen Haupt-Bundles.
      const treffer = /\/main\.([0-9a-f]{8,})\.js/.exec(skript.src);
      if (treffer) return treffer[1].slice(0, 8);
    }
  } catch {
    // Kein DOM-Zugriff moeglich - dann eben ohne Kennung.
  }
  return '';
}
